var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-navbar",
    {
      staticClass:
        "showLargeScreenOnly d-flex justify-content-between p-4 h-80px",
      attrs: { type: "faded" },
    },
    [
      _c(
        "div",
        { staticClass: "d-flex" },
        [
          _c(
            "b-navbar-brand",
            { staticClass: "py-4 p-xl-3", attrs: { href: "#" } },
            [
              _c("img", {
                staticClass: "heritage-web-header largescreen",
                attrs: { src: _vm.imgVarsLong, alt: "MoneyRoad" },
                on: { click: _vm.loadAccueil },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-navbar-nav",
            { key: _vm.resetMenu, staticClass: "m-auto", attrs: { fill: "" } },
            _vm._l(_vm.menu, function (item, id) {
              return !_vm.isDisabledItem(item)
                ? _c(
                    "span",
                    [
                      item.list
                        ? _c(
                            "div",
                            {
                              on: {
                                mouseover: function ($event) {
                                  return _vm.autoDropdown(true, "dropdown" + id)
                                },
                                mouseleave: function ($event) {
                                  return _vm.autoDropdown(
                                    false,
                                    "dropdown" + id
                                  )
                                },
                              },
                            },
                            [
                              _vm.hasOneRight(item.list)
                                ? _c(
                                    "b-nav-item-dropdown",
                                    {
                                      ref: "dropdown" + id,
                                      refInFor: true,
                                      staticClass:
                                        "h5 font-weight-bold dropDownInnerWebHeader p-1 p-xl-2 pr-xl-4 mt-3",
                                      attrs: {
                                        "toggle-class": "text-menu",
                                        text: _vm.$t(item.title),
                                      },
                                    },
                                    [
                                      _c(
                                        "b-dropdown-group",
                                        _vm._l(item.list, function (subitem) {
                                          return subitem.enabled &&
                                            _vm.canShowSpecific(subitem) &&
                                            !_vm.isDisabledItem(subitem)
                                            ? _c(
                                                "b-dropdown-item",
                                                {
                                                  key: subitem.id,
                                                  staticClass:
                                                    "dropdown-item-web-header",
                                                  class:
                                                    subitem.id === 0
                                                      ? "subItemMenuWebHeader"
                                                      : "subItemTextWebHeader",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.getClicked(
                                                        subitem
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                " +
                                                      _vm._s(
                                                        _vm.$t(subitem.title)
                                                      ) +
                                                      "\n                "
                                                  ),
                                                  !subitem.link
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "disabled ml-1",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "common.dsbld"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              )
                                            : _vm._e()
                                        }),
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : item.enabled
                        ? _c(
                            "b-nav-item",
                            {
                              staticClass:
                                "h5 text-menu subItemTextOnlyWebHeader p-1 p-xl-2 pr-xl-4 mt-3 font-weight-bold",
                              class: {
                                selectedMenuItemWebHeader:
                                  _vm.selectedMenu === item.link,
                              },
                              attrs: {
                                disabled: _vm.isDisabledItem(item),
                                "link-classes": "subItemLink",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.getClicked(item)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t(item.title)) +
                                  "\n          "
                              ),
                              !item.link
                                ? _c("span", { staticClass: "disabled ml-1" }, [
                                    _vm._v(_vm._s(_vm.$t("common.dsbld"))),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              item.link == _vm.selectedMenu
                                ? _c("div", {
                                    staticClass:
                                      "border-success border-bottom pt-2",
                                    attrs: {
                                      commented_style:
                                        "border-bottom:1px solid var(--actionButtonColorBlue); padding-top:10px;",
                                    },
                                  })
                                : _c("div", {
                                    staticClass: "opacity-0 border-bottom pt-2",
                                    attrs: {
                                      commented_style: "padding-top:10px",
                                    },
                                  }),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e()
            }),
            0
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex justify-content-around" },
        [
          _c(
            "b-navbar-nav",
            { staticClass: "mx-0 mx-lg-3", attrs: { fill: "" } },
            [
              _c(
                "div",
                {
                  on: {
                    mouseover: function ($event) {
                      return _vm.autoDropdown(true, "log")
                    },
                    mouseleave: function ($event) {
                      return _vm.autoDropdown(false, "log")
                    },
                  },
                },
                [
                  this.$engine.user && this.$engine.user.userAccountId !== 1
                    ? _c(
                        "b-nav-item-dropdown",
                        {
                          ref: "log",
                          staticClass: "logOut",
                          attrs: {
                            "toggle-class": "d-flex align-items-center",
                            right: "",
                            variant: "link",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "button-content",
                                fn: function () {
                                  return [
                                    _c("img", {
                                      staticClass: "navbarProfileImage mr-2",
                                      attrs: { src: _vm.imgProfil },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex flex-column align-items-start",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "d-none d-xl-inline mr-2 h5 mb-0 text-menu profile-menu",
                                          },
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.companyName) +
                                                  " "
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "d-none d-xl-inline mr-2 mb-0 text-menu profile-menu",
                                          },
                                          [
                                            _vm._v(
                                              "  " + _vm._s(_vm.userName) + " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            3167362466
                          ),
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "b-dropdown-item",
                            {
                              staticClass:
                                "subItemTextWebHeader dropdown-item-web-header",
                              on: {
                                click: function ($event) {
                                  return _vm.goToLink("/profile/")
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("leftPanelTitle.my_prfl")))]
                          ),
                          _vm._v(" "),
                          _vm.hasMultipleAccounts()
                            ? _c(
                                "b-dropdown-item",
                                {
                                  staticClass:
                                    "subItemTextWebHeader dropdown-item-web-header",
                                  on: { click: _vm.activateModalProfile },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("leftPanelTitle.swtch_prfl"))
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$engine.rights.rightIs("settings_consulter", true)
                            ? _c(
                                "b-dropdown-item",
                                {
                                  staticClass:
                                    "subItemTextWebHeader dropdown-item-web-header",
                                  on: {
                                    click: function ($event) {
                                      return _vm.goToLink(
                                        "/settings/application/"
                                      )
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("Webheader.settings")))]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-navbar-nav",
            { staticClass: "mx-1 my-2 m-lg-2", attrs: { fill: "" } },
            [
              _c(
                "b-button",
                {
                  staticClass: "px-2 px-lg-4 d-none-max-849px text-nowrap",
                  attrs: { variant: "primary" },
                  on: { click: _vm.logout },
                },
                [
                  _c("span", { staticClass: "d-none-max-1459px" }, [
                    _vm._v(" " + _vm._s(_vm.$t("leftPanelTitle.lgout")) + " "),
                  ]),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "d-none-min-1460px fa fa-power-off fs-14px",
                  }),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-navbar-nav",
            { staticClass: "mx-0 mx-lg-3", attrs: { fill: "" } },
            [
              _c(
                "b-dropdown",
                {
                  attrs: {
                    right: "",
                    "toggle-class": "border-0 p-0 bg-none m-md-2 text-dark",
                  },
                  model: {
                    value: _vm.language,
                    callback: function ($$v) {
                      _vm.language = $$v
                    },
                    expression: "language",
                  },
                },
                [
                  _c("template", { slot: "button-content" }, [
                    _c("img", {
                      staticClass: "flag-nav",
                      attrs: {
                        src:
                          _vm.language === "FR"
                            ? _vm.logoFlagFR
                            : _vm.logoFlagEN,
                      },
                    }),
                    _c("span", { staticClass: "d-none-max-1459px mr-1" }, [
                      _vm._v(_vm._s(_vm.labelLanguage)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.options, function (option) {
                    return _c(
                      "b-dropdown-item",
                      {
                        key: option.value,
                        staticClass: "dropdown-item-web-header",
                        on: {
                          click: function ($event) {
                            return _vm.languageCountry(option.value)
                          },
                        },
                      },
                      [
                        option.value === "FR"
                          ? _c("img", {
                              staticClass: "flag-nav",
                              attrs: { src: _vm.logoFlagFR },
                            })
                          : _c("img", {
                              staticClass: "flag-nav",
                              attrs: { src: _vm.logoFlagEN },
                            }),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(option.text))]),
                      ]
                    )
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }